import { service } from "../utils/request";

//  会员系统中的营销模块

// 消费后有礼
export function addConsumption(data) {
  return service({
    url: "/user/agent.Config_Consume/add",
    method: "post",
    data: data
  });
}
export function manage_add(data) {
  return service({
    url: "manage/task.task/add",
    method: "post",
    data: data
  });
}
export function manage_list(data) {
  return service({
    url: "manage/task.task/index",
    method: "get",
    params: data
  });
}
export function manage_del(data) {
  return service({
    url: "manage/task.task/del",
    method: "post",
    data: data
  });
}
export function manage_detail(data) {
  return service({
    url: "manage/task.task/detail",
    method: "get",
    params: data
  });
}
export function manage_edit(data) {
  return service({
    url: "manage/task.task/edit",
    method: "post",
    data: data
  });
}
export function edit_baseinfo(data) {
  return service({
    url: "manage/task.task/edit_baseinfo",
    method: "post",
    data: data
  });
}
export function listConsumption(data) {
  return service({
    url: "/user/agent.Config_Consume/index",
    method: "post",
    data: data
  });
}
export function detailConsumption(data) {
  return service({
    url: "/user/agent.Config_Consume/detail",
    method: "post",
    data: data
  });
}
export function editConsumption(data) {
  return service({
    url: "user/agent.Config_Consume/edit",
    method: "post",
    data: data
  });
}
export function delConsumption(data) {
  return service({
    url: "user/agent.Config_Consume/del",
    method: "post",
    data: data
  });
}
// 关注有礼
export function addAttention(data) {
  return service({
    url: "/api/config.market_subscribe/addActive",
    method: "post",
    data: data
  });
}
export function listAttention(data) {
  return service({
    url: "/api/config.market_subscribe/index",
    method: "post",
    data: data
  });
}
export function detailAttention(data) {
  return service({
    url: "/api/config.market_subscribe/getActive",
    method: "post",
    data: data
  });
}
export function editAttention(data) {
  return service({
    url: "/api/config.market_subscribe/editActive",
    method: "post",
    data: data
  });
}
export function delAttention(data) {
  return service({
    url: "/api/config.market_subscribe/delActive",
    method: "post",
    data: data
  });
}
// 会员标签 -自动
export function addTag(data) {
  return service({
    url: "/user/agent.config_users_tag/addAutoTag",
    method: "post",
    data: data
  });
}
export function listTag(data) {
  return service({
    url: "/user/agent.config_users_tag/autoTag",
    method: "post",
    data: data
  });
}
export function detailTag(data) {
  return service({
    url: "/user/agent.config_users_tag/autoDetail",
    method: "post",
    data: data
  });
}

// 手动更新自动标签
export function updateTag(data) {
  return service({
    url: "/user/agent.config_users_tag/renew",
    method: "post",
    data: data
  });
}
// export function editTag(data) {
//   return service({
//     url: "/api/config.market_subscribe/editActive",
//     method: "post",
//     data: data
//   });
// }
// 所有标签都可删除
export function delTag(data) {
  return service({
    url: "/user/agent.config_users_tag/delTag",
    method: "post",
    data: data
  });
}

// 会员标签 -手动
export function addCommonTag(data) {
  return service({
    url: "/user/agent.config_users_tag/addCommonTag",
    method: "post",
    data: data
  });
}
export function msgIgnoreList(data) {
  return service({
    url: "/manage/user.user_ignore/msgIgnoreList",
    method: "post",
    data: data
  });
}
export function addMsgIgnore(data) {
  return service({
    url: "/manage/user.user_ignore/addMsgIgnore",
    method: "post",
    data: data
  });
}

export function removeMsgIgnore(data) {
  return service({
    url: "/manage/user.user_ignore/removeMsgIgnore",
    method: "post",
    data: data
  });
}
export function listCommonTag(data) {
  return service({
    url: "/user/agent.config_users_tag/commonTag",
    method: "post",
    data: data
  });
}
export function eaditCommonTag(data) {
  return service({
    url: "/user/agent.config_users_tag/editCommonTag",
    method: "post",
    data: data
  });
}
export function detailCommonTag(data) {
  return service({
    url: "/user/agent.config_users_tag/detailCommonTag",
    method: "post",
    data: data
  });
}
// 获取全部的标签
export function allTag(data) {
  return service({
    url: "/user/agent.config_users_tag/allTag",
    method: "post",
    data: data
  });
}

// 会员添加手动标签
export function setUserTag(data) {
  return service({
    url: "/user/agent.config_users_tag/addUserTag",
    method: "post",
    data: data
  });
}

// 删除会员手动标签
export function delUserTag(data) {
  return service({
    url: "/user/agent.config_users_tag/delUserTag",
    method: "post",
    data: data
  });
}
// 群发服务通知
export function massTexting(data) {
  return service({
    url: "wechat/agent.notice/addNotice",
    method: "post",
    data: data
  });
}
// 价立减
export function CardConsumeAdd(data) {
  return service({
    url: "/api/config.Card_Consume/add",
    method: "post",
    data: data
  });
}
export function CardConsumeEditor(data) {
  return service({
    url: "/api/config.Card_Consume/edit",
    method: "post",
    data: data
  });
}
export function CardConsumeIndex(data) {
  return service({
    url: "/api/config.Card_Consume/index",
    method: "post",
    data: data
  });
}
export function CardConsumeDetail(data) {
  return service({
    url: "/api/config.Card_Consume/detail",
    method: "post",
    data: data
  });
}
export function CardConsumeDel(data) {
  return service({
    url: "/api/config.Card_Consume/del",
    method: "post",
    data: data
  });
}
export function noticeHistory(data) {
  return service({
    url: "wechat/agent.notice/history",
    method: "post",
    data: data
  });
}
// 积分削减消分任务
export function PointsTaskDel(data) {
  return service({
    url: "user/agent.PointsTask/del",
    method: "post",
    data: data
  });
}
export function PointsTaskDetail(data) {
  return service({
    url: "user/agent.PointsTask/detail",
    method: "post",
    data: data
  });
}
export function PointsTaskIndex(data) {
  return service({
    url: "user/agent.PointsTask/index",
    method: "post",
    data: data
  });
}
export function PointsTaskAdd(data) {
  return service({
    url: "user/agent.PointsTask/add",
    method: "post",
    data: data
  });
}
export function PointsTaskEdit(data) {
  return service({
    url: "user/agent.PointsTask/edit",
    method: "post",
    data: data
  });
}
// 邀请有礼
export function getInviteList(data) {
  return service({
    url: "manage/activity.invite/inviteList",
    method: "post",
    data: data
  });
}
// 添加邀请有礼
export function addInvite(data) {
  return service({
    url: "manage/activity.invite/addInvite",
    method: "post",
    data: data
  });
}
// 取消邀请有礼
export function cancelInvite(data) {
  return service({
    url: "manage/activity.invite/cancelInvite",
    method: "post",
    data: data
  });
}
// 获取邀请有礼设置
export function getInviteConfig(data) {
  return service({
    url: "manage/activity.invite/getConfig",
    method: "post",
    data: data
  });
}
// 获取邀请有礼设置
export function inviteQrcode(data) {
  return service({
    url: "manage/activity.invite/inviteQrcode",
    method: "post",
    data: data
  });
}
// 积分商城
export function categoryList(data) {
  return service({
    url: "creditshop/agent.Cate/index",
    method: "post",
    data: data
  });
}
// 添加
export function addCommodity(data) {
  return service({
    url: "creditshop/agent.Cate/add",
    method: "post",
    data: data
  });
}
// 编辑
export function editMessage(data) {
  return service({
    url: "creditshop/agent.Cate/edit",
    method: "post",
    data: data
  });
}
// 删除
export function deleteNumber(data) {
  return service({
    url: "creditshop/agent.Cate/del",
    method: "post",
    data: data
  });
}
//商品管理
export function ManagementList(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/index",
    method: "post",
    data: data
  });
}
export function Commodity_category(data) {
  return service({
    url: "creditshop/agent.Cate/index",
    method: "post",
    data: data
  });
}
// 添加
export function addGoods(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/add",
    method: "post",
    data: data
  });
}
// 状态修改
export function modifyState(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/openStatus",
    method: "post",
    data: data
  });
}
// 编辑
export function editGoods(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/edit",
    method: "post",
    data: data
  });
}
// 商品详情
export function productDetail(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/detail",
    method: "post",
    data: data
  });
}
// 删除
export function deleteGoods(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods/del",
    method: "post",
    data: data
  });
}

//余额抵扣设置
//获取配置
export function getcreditshopconfig(data) {
  return service({
    url: "creditshop/agent.creditshop_goods/get_creditshop_balance_config",
    method: "post",
    data: data
  });
}
//修改配置
export function setcreditshopconfig(data) {
  return service({
    url: "creditshop/agent.creditshop_goods/set_creditshop_balance_config",
    method: "post",
    data: data
  });
}
export function history_logs(data) {
  return service({
    url: "manage/task.point_temp/history",
    method: "post",
    data: data
  });
}
export function send_point(data) {
  return service({
    url: "manage/task.point_temp/send_point_temp",
    method: "post",
    data: data
  });
}